/**
 * Custom event_label list
 * 'go_to_buy'
 * 'write_msg'
 * 'submit'
 * 'back_to_index'
 * 'register_receipt'
 */

const MEASUREMENT_ID = 'UA-130594876-1'
const CONVERSION_ID = 'AW-686455989'
const config = { page_path: '/index' } // 動態更新 path

window.dataLayer = window.dataLayer || []
function gtag() {
  window.dataLayer.push(arguments)
}

export default {
  /** Load global gtag.js vis html script tag */
  initGtag() {
    // Add script tag to HTML for import global gtag
    const scriptDOM = document.createElement('script')
    scriptDOM.setAttribute('async', true)
    scriptDOM.setAttribute(
      'src',
      `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`
    )
    document.head.appendChild(scriptDOM)

    // Init gtag
    gtag('js', new Date())
    gtag('config', MEASUREMENT_ID, config)
    gtag('config', CONVERSION_ID, config)
  },

  /**
   * Send gtag event to Google Analytics
   * @param {string} label
   */
  sendClickEvent(label) {
    const config = {
      event_category: 'web_ar',
      event_label: label,
    }

    gtag('event', 'btn_click', config)
  },

  sendPageView(path) {
    // 防止初次進入誤送兩次 page_view
    if (path === config.page_path) return void 0
    this._updatePath(path)
    gtag('config', MEASUREMENT_ID, { page_path: path })
  },

  _updatePath(path) {
    config.page_path = path
  },

  allowGtag() {
    window[`ga-disable-${MEASUREMENT_ID}`] = false
  },

  disallowGtag() {
    window[`ga-disable-${MEASUREMENT_ID}`] = true
  },
}
